import { ctoExtranjero } from "AppData"

export const texts = {
    PAGE_TITLE: 'Alta de usuario con contraseña',
    confirmacion: {
        titulo: 'Alta realizada correctamente',
        mensaje: 'Recibirá un correo con el usuario asignado para iniciar sesión en la Oficina Virtual'
    }
}

export const objComponentFormio = {    
    aliasFormulario: 'altaUsuarioConContrasena',
    sp: {
        complete: '',
        error: 'Hubo un problema',
        next: 'Siguiente',
        previous: 'Atrás',
        cancel: 'Cancelar',
        submit: 'Guardar',
        required: 'Es obligatorio rellenar este campo',
        confirmCancel: '¿Estás seguro que quieres cancelar?',
        submitError: 'Por favor revise el formulario y corrija todos los errores.',
        pattern: 'El valor no cumple con el patrón requerido',
        email: 'Debe ser una dirección de correo electrónico válida',
        invalid_regex: 'El valor insertado no es válido',
        characters: 'caracteres.'
    }
}

export const cruds = {
    altaUsuario: {
        resource: 'login-usuario',
        url: ''
    },
    tipoVia: {
        resource: 'tipoVia',
        url: '/findByCodigo/'
    },
    tipoInteresado: {
        resource: 'tipo-interesado',
        url: '/findByCodigo/'
    },
    interesado: {
        resource: 'interesado',
        url: '/existIdentificadorInteresado/'
    },
    isEmailUsed: {
        resource: 'datos-contacto',
        url: '/isEmailUsed/'
    }
}

export const nuevoUsuario = {
    identificador: '',
    contrasena: '',
    interesadoDto: {
        nombre: '',
        apellido1: '',
        apellido2: '',
        tipoIdentificador: 'PASAPORTE',
        identificador: '',
        sexo: '',
        fechaNacimiento: '',
        datosContactoPorDefecto: {
            email: '',
            telefono: '',
            telefonoMovil: '',
            tipoVia: {},
            nombreVia: '',
            numero: '',
            piso: '',
            letra: '',
            puerta: '',
            escalera: '',
            idPais: '',
            pais: {},
            postal: '',
            tipoInteresado: {},
            tipoNotificacion: 'Electrónica',
            // Valores por defecto si no se recibe provincia y municipio
            provincia: { id: ctoExtranjero.idProvincia },
            idProvincia: ctoExtranjero.idProvincia,
            municipio: { id: ctoExtranjero.idMunicipio },
            idMunicipio: ctoExtranjero.idMunicipio,
        }
    }
}